export default {
  image: 'A3_1.png',
  pdf: '220922_WA-OWDVS_002_A3_1_Rev02_ar.pdf',
  productData: {
    serialNumber: 'WA-OWDVS-002',
    technicalValues: {
      soundReductionIndex: {
        output: '51,0',
        value: 51
      },
      heatTransferCoefficient: {
        output: '0,45',
        value: 0.45
      },
      fireResistanceOuter: {
        output: 'F 60-B',
        value: 'F-60-B'
      },
      fireResistanceInner: {
        output: 'F 60-B',
        value: 'F-60-B'
      },
      fireBehavior: {
        output: 'keine Angabe',
        value: null
      },
    },
    name: 'Wandaufbau ohne WDVS l Aufbau 2',
    construction: {
      composition: [
        {
          output: 'ohne',
          type: 'render',
          title: { de: 'Putz' },
          value: null
        },
        {
          output: 'keine',
          type: 'pinsulation', 
          title: { de: 'Dämmung' },
          value: null
        },
        {
          output: '2 x 12,5 mm Gipsfaserplatten',
          type: 'outerPlanking',
          title: { de: 'Beplankung Außen' },
          value: 'opg-25'
        },
        {
          output: '60/80',
          type: 'stand',
          title: { de: 'Ständer' },
          value: 'stae-80'
        },
        {
          output: '80 mm Glaswolle',
          type: 'compartmentInsulation',
          title: { de: 'Gefachdämmung' },
          value: 'cigw-80'
        },
        {
          output: '12,5 mm Gipsfaserplatte',
          type: 'innerPlanking1',
          title: { de: 'Beplankung Innen 1. Lage' },
          value: 'if-12'
        },
        {
          output: '12,5 mm Gipsfaserplatte',
          type: 'innerPlanking2',
          title: { de: 'Beplankung Innen 2. Lage' },
          value: 'io-12'
        }, 
        {
          output: 'keine',
          type: 'innerPlanking3',
          title: { de: 'Beplankung Innen 3. Lage' },
          value: null
        }
      ],
      sum: {
        output: '130',
        value: 130
      }
    }
  }
}
